import { apiClient } from './client';
import type {
  Migration,
  MigrationDetail,
  MigrationsResponse,
  MigrationFilters,
  CreateMigrationData,
  UpdateMigrationData,
  ExecuteMigrationResponse,
  MigrationStatusResponse,
} from '@/types/migration';

export async function getMigrations(filters: MigrationFilters = {}): Promise<MigrationsResponse> {
  const params = new URLSearchParams();

  if (filters.search) {
    params.append('search', filters.search);
  }
  if (filters.page) {
    params.append('page', filters.page.toString());
  }
  if (filters.limit) {
    params.append('limit', filters.limit.toString());
  }
  if (filters.sortBy) {
    params.append('sortBy', filters.sortBy);
  }
  if (filters.sortOrder) {
    params.append('sortOrder', filters.sortOrder);
  }

  const response = await apiClient.get<MigrationsResponse>(`/api/migrations?${params.toString()}`);
  return response.data;
}

export async function getMigration(id: number): Promise<MigrationDetail> {
  const response = await apiClient.get<MigrationDetail>(`/api/migrations/${id}`);
  return response.data;
}

export async function createMigration(data: CreateMigrationData): Promise<{ id: number; name: string; message: string }> {
  const response = await apiClient.post<{ id: number; name: string; message: string }>('/api/migrations', data);
  return response.data;
}

export async function updateMigration(id: number, data: UpdateMigrationData): Promise<{ id: number; name: string; message: string }> {
  const response = await apiClient.put<{ id: number; name: string; message: string }>(`/api/migrations/${id}`, data);
  return response.data;
}

export async function deleteMigration(id: number): Promise<void> {
  await apiClient.delete(`/api/migrations/${id}`);
}

export async function executeMigration(id: number): Promise<ExecuteMigrationResponse> {
  const response = await apiClient.post<ExecuteMigrationResponse>(`/api/migrations/${id}/execute`);
  return response.data;
}

export async function getMigrationStatus(id: number): Promise<MigrationStatusResponse> {
  const response = await apiClient.get<MigrationStatusResponse>(`/api/migrations/${id}/status`);
  return response.data;
}

export const migrationsApi = {
  getAll: getMigrations,
  getOne: getMigration,
  create: createMigration,
  update: updateMigration,
  delete: deleteMigration,
  execute: executeMigration,
  getStatus: getMigrationStatus,
};
